import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "submit",
    class: "btn-primary bg-blue-500 hover:bg-blue-700 border text-white font-semibold text-sm py-2 px-4 rounded-xl w-full mt-5 disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed",
    disabled: _ctx.isDisabled
  }, _toDisplayString(_ctx.isLogin ? 'LOGIN' : 'ENVIAR CÓDIGO'), 9, _hoisted_1))
}